import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../providers/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardRedirectGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    if (state.url.includes('/defect/')) {
      return true;
    }
    
    return this.authService.checkToken().then((value) => {
      if (!this.authService.authenticationState.getValue()) {
        return true;
      }

      let user = this.authService.user;
      if (!user) {
        user = this.authService.getUserProfile();
        if (!user) {
          return true;
        }
      }
      
      if (!user || !user.extra_vars || !user.extra_vars.permissions) {
        return true;
      }

      const hasDepotKioskPermission = user.extra_vars.permissions.some(
        (perm: any) => perm.PermissionName === 'Defect Depot Kiosk'
      );
      
      if (hasDepotKioskPermission) {
        this.router.navigateByUrl('/dashboard-depot');
        return false;
      }
      return true;
    }).catch((error) => {
      console.log('DashboardRedirectGuard - error:', error);
      return true;
    });
  }
}
